import { get, post, del } from ".";

export const getCommentsApi = async (projectId, tagged, search, category, status, damagingEnergy, pso, dateFrom, dateTo, assignToMe) => {
  return await get(`project/${projectId}/comments`, {
    params: { tagged, search, category, status, damagingEnergy, pso, dateFrom, dateTo, assignToMe },
  });
};

export const getCommentsDetailsApi = async (projectId, bimElementId, commentId) => {
  return await get(`project/${projectId}/comments/details`, { params: { bimElementId, commentId } });
};

export const createNewCommentsApi = async (projectId, params) => {
  return await post(`project/${projectId}/comments/new-comment`, params);
};

export const uploadNewCommentsFileApi = async (projectId, commentId, params) => {
  return await post(`project/${projectId}/comments/new-comment-file?commentId=${commentId}`, params);
};

export const resolveCommentsApi = async (projectId, commentId) => {
  return await post(`project/${projectId}/comments/resolve-comment?commentId=${commentId}`);
};

export const deleteCommentFileApi = async (projectId, commentFileId) => {
  return await del(`project/${projectId}/comments/disable-comment-file?commentFileId=${commentFileId}`);
};

export const sendCommentNotificationApi = async (projectId, commentId) => {
  return await post(`project/${projectId}/comments/send-comment-notification?commentId=${commentId}`);
};

export const getSafetyObservationApi = async (projectId) => {
  return await get(`project/${projectId}/comments/safety-observations`);
};